export const OPEN_UNSYNCABLE_RECIPIENTS_MODAL =
  'OPEN_UNSYNCABLE_RECIPIENTS_MODAL';
export const CLOSE_UNSYNCABLE_RECIPIENTS_MODAL =
  'CLOSE_UNSYNCABLE_RECIPIENTS_MODAL';
